/**
 * Animation « fly to cart » inspirée d'Odoo website_sale (animateClone).
 * L'image produit se déplace vers l'icône panier puis le compteur pulse.
 */
(function () {
  const MOVE_DURATION = 500;
  const SHRINK_DURATION = 200;
  const FLY_SIZE = 75;

  function isVisible(el) {
    if (!el || !el.isConnected) return false;
    const rect = el.getBoundingClientRect();
    if (rect.width <= 0 || rect.height <= 0) return false;
    const style = window.getComputedStyle(el);
    return style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) > 0;
  }

  function getCartTarget() {
    const candidates = [
      document.querySelector('[data-massin-cart-toggle]'),
      document.getElementById('cart-icon-bubble')
    ];

    for (const el of candidates) {
      if (isVisible(el)) return el;
    }

    return document.getElementById('cart-icon-bubble') || document.querySelector('[data-massin-cart-toggle]');
  }

  function getSearchRoot(sourceEl) {
    if (sourceEl.closest('.massin-product-card')) return sourceEl.closest('.massin-product-card');
    if (sourceEl.closest('.card-wrapper')) return sourceEl.closest('.card-wrapper');
    if (sourceEl.closest('quick-add-modal')) return sourceEl.closest('quick-add-modal');
    if (sourceEl.closest('amazon-product-details')) return sourceEl.closest('amazon-product-details');

    const productGrid = sourceEl.closest('.product');
    if (productGrid) return productGrid;

    const mainProduct = sourceEl.closest('[id^="MainProduct-"]');
    if (mainProduct) return mainProduct;

    return sourceEl.closest('product-form') || sourceEl;
  }

  function findProductImage(sourceEl) {
    const root = getSearchRoot(sourceEl);
    const selectors = [
      '.product__media-item.is-active img',
      'media-gallery .product__media-item.is-active img',
      '.massin-carousel__slide.is-active img',
      '.massin-product-card__image',
      'media-gallery img',
      '.product__media img',
      '.card__media img',
      '.amazon-product-main-image img',
      '.product__modal-opener img',
      'img[src*="cdn.shopify"]',
      'img'
    ];

    for (const selector of selectors) {
      const candidates = root.querySelectorAll(selector);
      for (const img of candidates) {
        if (!img.src || !isVisible(img)) continue;
        const rect = img.getBoundingClientRect();
        if (rect.width > 0 && rect.height > 0) return img;
      }
    }

    return null;
  }

  function pulseCartHighlight(cartTarget) {
    cartTarget.classList.add('massin-cart-fly__highlight', 'massin-cart-fly__shadow');
    window.setTimeout(() => cartTarget.classList.remove('massin-cart-fly__shadow'), 500);
    window.setTimeout(() => cartTarget.classList.remove('massin-cart-fly__highlight'), 2700);
  }

  function pulseCartZoom(cartTarget) {
    cartTarget.classList.add('massin-cart-fly__zoom');
    window.setTimeout(() => cartTarget.classList.remove('massin-cart-fly__zoom'), 320);
  }

  function pulseCartOnly() {
    const cart = getCartTarget();
    if (cart) pulseCartZoom(cart);
  }

  function flyClone(sourceImg, cartTarget) {
    const imgRect = sourceImg.getBoundingClientRect();
    const cartRect = cartTarget.getBoundingClientRect();

    const startW = imgRect.width;
    const startH = imgRect.height;
    const destX = cartRect.left + (cartRect.width - FLY_SIZE) / 2;
    const destY = cartRect.top + (cartRect.height - FLY_SIZE) / 2;
    const scaleX = FLY_SIZE / startW;
    const scaleY = FLY_SIZE / startH;

    const clone = sourceImg.cloneNode(true);
    clone.className = 'massin-cart-fly-clone';
    clone.removeAttribute('id');
    clone.removeAttribute('loading');
    clone.removeAttribute('srcset');
    clone.removeAttribute('sizes');

    Object.assign(clone.style, {
      position: 'fixed',
      top: '0',
      left: '0',
      width: `${startW}px`,
      height: `${startH}px`,
      margin: '0',
      padding: '0',
      pointerEvents: 'none',
      objectFit: 'cover',
      borderRadius: '4px',
      zIndex: '10000',
      transformOrigin: 'top left',
      willChange: 'transform, opacity',
      transform: `translate3d(${imgRect.left}px, ${imgRect.top}px, 0) scale(1)`
    });

    document.body.appendChild(clone);
    pulseCartHighlight(cartTarget);

    return new Promise((resolve) => {
      const moveAnim = clone.animate(
        [
          {
            transform: `translate3d(${imgRect.left}px, ${imgRect.top}px, 0) scale(1)`,
            opacity: 0.85
          },
          {
            transform: `translate3d(${destX}px, ${destY}px, 0) scale(${scaleX}, ${scaleY})`,
            opacity: 0.85
          }
        ],
        { duration: MOVE_DURATION, easing: 'ease-in-out', fill: 'forwards' }
      );

      const finish = () => {
        clone.remove();
        pulseCartZoom(cartTarget);
        resolve();
      };

      moveAnim.addEventListener('finish', () => {
        const shrinkAnim = clone.animate(
          [
            {
              transform: `translate3d(${destX}px, ${destY}px, 0) scale(${scaleX}, ${scaleY})`,
              opacity: 0.85
            },
            {
              transform: `translate3d(${destX + FLY_SIZE / 2}px, ${destY + FLY_SIZE / 2}px, 0) scale(0, 0)`,
              opacity: 0
            }
          ],
          { duration: SHRINK_DURATION, easing: 'ease-in', fill: 'forwards' }
        );

        shrinkAnim.addEventListener('finish', finish);
        shrinkAnim.addEventListener('cancel', finish);
      });

      moveAnim.addEventListener('cancel', finish);
    });
  }

  function animate(sourceEl) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      pulseCartOnly();
      return Promise.resolve();
    }

    const cartTarget = getCartTarget();
    const productImg = findProductImage(sourceEl);

    if (!cartTarget || !productImg) {
      pulseCartOnly();
      return Promise.resolve();
    }

    return flyClone(productImg, cartTarget);
  }

  window.MassinCartFlyAnimation = { animate };
})();
